/*
  Her gift page: crazysneak.com/pages/her-gift#<link token>

  Screens (Claude Design "CrazySneak Recipient Journey"):
    open → design (gift-designer.js) → details → review → [email code + confirm: next stage]
    plus: used (already claimed), paused, invalid link, temporary error.

  The token after "#" never reaches Shopify or analytics. It is sent only to our own worker,
  in the request body. Everything she chooses is saved to the worker as she goes.
*/
(function () {
  'use strict';

  var root = document.getElementById('gs');
  if (!root) return;
  var API = root.dataset.api;
  var CONFIG_URL = root.dataset.config;
  var ASSET_BASE = root.dataset.assetBase;
  var ICONS = JSON.parse(root.dataset.icons || '{}');
  var EXTRA_FONT_CSS = root.dataset.fontCss || '';
  var main = root.querySelector('[data-gs-main]');
  var headRight = root.querySelector('[data-gs-head-right]');
  var toastEl = root.querySelector('[data-gs-toast]');

  // Kept in step with worker/src/recipient/countries.ts
  var COUNTRIES = ('AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ ' +
    'CA CC CD CF CG CH CI CK CL CM CN CO CR CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR ' +
    'GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IO IQ IS IT JE JM JO JP ' +
    'KE KG KH KI KM KN KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS ' +
    'MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO ' +
    'RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SZ TC TD TG TH TJ TK TL TM TN TO TR TT TV TW ' +
    'TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW').split(' ');
  var regionNames = null;
  try { regionNames = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) {}
  function countryName(code) { try { return (regionNames && regionNames.of(code)) || code; } catch (e) { return code; } }
  var COUNTRY_OPTIONS = COUNTRIES.map(function (c) { return { code: c, name: countryName(c) }; })
    .sort(function (a, b) { return a.name.localeCompare(b.name, 'en'); });

  var token = (location.hash.match(/^#([0-9a-f]{24})\b/i) || [])[1] || '';
  // "#<token>&preview" (button in the giver's email): look around, nothing is saved or logged,
  // and her own saved design is never shown.
  var PREVIEW = /[#&]preview\b/i.test(location.hash);
  // Up to 10 days to make a pair + up to 7 days delivery (kept in step with worker/src/recipient/wedding.ts).
  var WEDDING_LEAD_DAYS = 17;
  function weddingTooSoon(v) {
    if (!v || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;
    var days = Math.floor((Date.parse(v + 'T12:00:00Z') - Date.now()) / 86400000);
    return !isNaN(days) && days < WEDDING_LEAD_DAYS;
  }
  function etaFromToday() {
    return new Date(Date.now() + WEDDING_LEAD_DAYS * 86400000).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }
  var SOON_TEXT = 'That’s very soon. We make each pair by hand (up to 10 days), and delivery takes up to 7 days. You can still confirm: we’ll email you within a day about timing.';
  var S = { screen: 'loading', cfg: null, gift: null, draft: null, designer: null, saveTimer: null, saving: false, again: false, lastSaved: null, tried: false, errors: {} };

  // ---------- helpers ----------
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var toastT = null;
  function toast(msg) { toastEl.textContent = msg; toastEl.hidden = false; clearTimeout(toastT); toastT = setTimeout(function () { toastEl.hidden = true; }, 2800); }
  function post(path, body) {
    return fetch(API + path, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit', referrerPolicy: 'no-referrer' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, data: d }; }); });
  }
  function byKey(list, key) { for (var i = 0; i < (list || []).length; i++) if (list[i].key === key) return list[i]; return null; }
  function sizeText(d) { var o = d && byKey(S.cfg.size.options, d.size); return o ? 'US ' + o.us + ' women · EU ' + o.eu : 'No size yet'; }
  function inscription(d) { return d && d.name ? d.name : 'No text'; }
  function fmtDate(v) {
    if (!v) return '';
    var d = new Date(v + 'T12:00:00');
    return isNaN(d) ? v : d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }
  function addrLines(f) {
    return [[f.line1, f.line2].filter(Boolean).join(', '), [f.city, f.region, f.zip].filter(Boolean).join(', '), f.country ? countryName(f.country) : '']
      .filter(Boolean);
  }
  function guessCountry() {
    var m = (navigator.language || '').match(/-([A-Z]{2})$/i);
    var c = m ? m[1].toUpperCase() : 'US';
    return COUNTRIES.indexOf(c) >= 0 ? c : 'US';
  }

  // ---------- autosave ----------
  function setSaved(text) { if (S.designer) S.designer.setSaved(text); }
  function saveSoon() {
    if (S.done || S.confirming || PREVIEW) return;
    setSaved('Saving…');
    clearTimeout(S.saveTimer);
    S.saveTimer = setTimeout(saveNow, 900);
  }
  function saveNow() {
    clearTimeout(S.saveTimer);
    if (PREVIEW) return Promise.resolve(true);
    if (S.saving) { S.again = true; return S.saving; }
    var d = S.draft;
    var p = post('/api/recipient/save', { token: token, rev: d.rev, design: d.design, details: d.details }).then(function (res) {
      if (res.status === 200) {
        // Keep whatever she typed while the request was on its way; only the revision comes from the server.
        S.draft.rev = res.data.draft.rev;
        S.draft.emailVerified = res.data.draft.emailVerified;
        setSaved('Saved ✓');
        return true;
      }
      if (res.status === 409 && res.data.draft) {
        // Saved from another tab or phone: take that version so nothing is overwritten silently.
        S.draft = res.data.draft;
        if (S.designer) S.designer.set(S.draft.design);
        toast('Updated with the changes you made on another screen.');
        if (S.screen !== 'design') show(S.screen);
        setSaved('Saved ✓');
        return true;
      }
      if (res.status === 409 || res.status === 404) { boot(); return false; }
      setSaved('Not saved — will retry');
      return false;
    }).catch(function () { setSaved('Offline — will retry'); return false; }).then(function (ok) {
      S.saving = null;
      if (S.again) { S.again = false; return saveNow(); }
      if (!ok) S.saveTimer = setTimeout(saveNow, 5000);
      return ok;
    });
    S.saving = p;
    return p;
  }
  // A last save when she leaves the page mid-way.
  window.addEventListener('pagehide', function () {
    if (!S.saveTimer || !S.draft || S.done) return;
    try {
      fetch(API + '/api/recipient/save', { method: 'POST', keepalive: true, headers: { 'content-type': 'application/json' }, credentials: 'omit',
        body: JSON.stringify({ token: token, rev: S.draft.rev, design: S.draft.design, details: S.draft.details }) });
    } catch (e) {}
  });

  // ---------- screens ----------
  function go(screen, push) {
    if (push !== false && screen !== S.screen) try { history.pushState({ gs: screen }, '', location.href); } catch (e) {}
    show(screen);
    window.scrollTo(0, 0);
  }
  window.addEventListener('popstate', function (e) {
    var s = e.state && e.state.gs;
    if (s && S.draft && (PREVIEW ? ['open', 'design', 'previewEnd'] : ['open', 'design', 'details', 'review']).indexOf(s) >= 0) show(s);
  });

  function stepper(cur) {
    return '<div class="gs-stepper">' + ['Design', 'Delivery', 'Review'].map(function (l, i) {
      return '<span class="' + (i < cur ? 'is-done' : (i === cur ? 'is-cur' : '')) + '">' + (i < cur ? '✓ ' : '') + l + '</span>';
    }).join('') + '</div>';
  }

  function show(screen) {
    S.screen = screen;
    document.body.classList.toggle('is-design', screen === 'design');
    main.className = 'gs-main' + (screen === 'design' ? ' gs-main--design' : '');
    void main.offsetWidth; main.classList.add('is-in');
    var g = S.gift || {};
    headRight.textContent = g.first && ['invalid', 'error', 'loading'].indexOf(screen) < 0 ? (PREVIEW ? 'Preview' : 'Gift for ' + g.first) : '';
    var banner = root.querySelector('[data-gs-preview]');
    if (banner) banner.hidden = !(PREVIEW && g.first && ['invalid', 'error', 'loading'].indexOf(screen) < 0);
    var designerHost = root.querySelector('[data-gs-designer]');

    if (screen === 'design') {
      main.innerHTML = '';
      main.appendChild(designerHost);
      designerHost.hidden = false;
      mountDesigner(designerHost);
      return;
    }
    // Park the designer (keeps its state and loaded pictures) instead of destroying it.
    if (designerHost.parentNode === main) { designerHost.hidden = true; root.appendChild(designerHost); }

    var html = RENDER[screen] ? RENDER[screen](g) : '';
    main.innerHTML = html;
    if (BIND[screen]) BIND[screen]();
  }

  var RENDER = {
    loading: function () { return '<div class="gs-loading">Opening your gift…</div>'; },

    open: function (g) {
      var started = S.draft && S.draft.rev > 0;
      var how = [['Design', 'Your size, pearls, crystals and name'], ['Delivery', 'Where we send your pair'], ['Confirm', 'We make them by hand for you']];
      return '<div class="gs-open">' +
        '<div class="gs-photo"><img src="' + esc(root.dataset.hero) + '" alt="A bride holding her gift card and her finished pair"></div>' +
        '<div class="gs-open__body">' +
          '<span class="gs-kicker">A gift for you</span>' +
          '<h1 class="gs-for">For ' + esc(g.first || 'you') + '</h1>' +
          (g.message
            ? '<figure class="gs-note-card"><blockquote>' + esc(g.message) + '</blockquote>' + (g.from ? '<figcaption>From ' + esc(g.from) + '</figcaption>' : '') + '</figure>'
            : (g.from ? '<span class="gs-from">From ' + esc(g.from) + '</span>' : '')) +
          '<div class="gs-paid"><span class="gs-label">Paid in full</span>' +
            '<div><i aria-hidden="true">✓</i>One pair of Bride Edition sneakers, designed by you</div>' +
            '<div><i aria-hidden="true">✓</i>Handmade, with tracked delivery to your door</div></div>' +
          '<div class="gs-cta">' +
            '<button class="gs-btn gs-btn--full" data-go="design">' + (started ? 'Continue my design' : 'Design my pair') + '</button>' +
            '<span class="gs-note">About 10 minutes · nothing to pay · ' + (PREVIEW ? 'nothing is saved in preview' : 'your progress saves as you go') + '</span>' +
          '</div>' +
          '<ol class="gs-how">' + how.map(function (h, i) { return '<li><b>0' + (i + 1) + '</b><span>' + h[0] + '</span><small>' + h[1] + '</small></li>'; }).join('') + '</ol>' +
        '</div></div>';
    },

    details: function () {
      var f = S.draft.details, e = S.errors;
      var field = function (k, label, attrs, opt, hint) {
        return '<label class="gs-field"><span>' + label + (opt ? '<i>Optional</i>' : '') + '</span>' +
          '<input class="gs-input' + (e[k] ? ' is-bad' : '') + '" data-f="' + k + '" value="' + esc(f[k]) + '" ' + (attrs || '') + '>' +
          (e[k] ? '<span class="gs-err">' + esc(e[k]) + '</span>' : '') + (hint ? '<span class="gs-hint">' + hint + '</span>' : '') + '</label>';
      };
      var options = COUNTRY_OPTIONS.map(function (c) { return '<option value="' + c.code + '"' + (c.code === f.country ? ' selected' : '') + '>' + esc(c.name) + '</option>'; }).join('');
      return '<div class="gs-stack" style="gap:clamp(22px,3vw,36px)">' + stepper(1) +
        '<div class="gs-form-grid"><div class="gs-stack" style="gap:clamp(22px,2.6vw,30px)">' +
          '<div class="gs-stack" style="gap:12px"><h1 class="gs-h1">Where should we send them?</h1><p class="gs-lead">We only use this for your order and its delivery.</p></div>' +
          '<div class="gs-fields">' +
            field('name', 'Full name', 'autocomplete="name" maxlength="100"') +
            field('email', 'Email', 'type="email" autocomplete="email" inputmode="email" maxlength="254"', false, 'We’ll send your order confirmation and tracking here.') +
          '</div>' +
          '<div class="gs-fields gs-fields--sep"><span class="gs-kicker" style="letter-spacing:.16em">Delivery address</span>' +
            '<label class="gs-field"><span>Country</span><select class="gs-input" data-f="country" autocomplete="country">' + options + '</select></label>' +
            field('line1', 'Street address', 'autocomplete="address-line1" maxlength="200"') +
            field('line2', 'Apartment, suite, floor', 'autocomplete="address-line2" maxlength="200"', true) +
            field('city', 'City', 'autocomplete="address-level2" maxlength="100"') +
            '<div class="gs-pair2">' + field('region', 'State / region', 'autocomplete="address-level1" maxlength="100"') + field('zip', 'ZIP / postcode', 'autocomplete="postal-code" maxlength="20"') + '</div>' +
            field('phone', 'Phone', 'type="tel" autocomplete="tel" maxlength="30"', true, 'Only if the courier needs to reach you.') +
          '</div>' +
          '<div class="gs-fields gs-fields--sep">' + field('wedding', 'Wedding date', 'type="date"', true, 'So we can plan for your pair to arrive in time.') +
            '<p class="gs-soon" data-gs-soon' + (weddingTooSoon(f.wedding) ? '' : ' hidden') + '>' + SOON_TEXT + '</p></div>' +
        '</div>' +
        '<div class="gs-side">' +
          '<div class="gs-mini"><div class="gs-mini__pic" data-gs-pv></div><div><b>Your pair</b><span>' + esc(sizeText(S.draft.design)) + '</span><span>Text: ' + esc(inscription(S.draft.design)) + '</span></div></div>' +
          '<div class="gs-sum"><div><span>Pair</span><span>Paid</span></div><div><span>Delivery</span><span>Paid</span></div>' +
            '<div class="gs-total"><span>To pay</span><span>$0</span></div></div>' +
          '<button class="gs-btn gs-btn--full" data-act="to-review">Review my pair</button>' +
          (Object.keys(e).length ? '<span class="gs-err" style="font-size:13.5px">A few details are missing above.</span>' : '') +
          '<button class="gs-link" style="align-self:center" data-go="design">Back to my design</button>' +
        '</div></div></div>';
    },

    review: function (g) {
      var d = S.draft.design, f = S.draft.details;
      var row = function (label, value, cls, target) {
        return '<div class="gs-row"><div><span class="gs-label">' + label + '</span>' + value + '</div><button class="gs-link" data-go="' + target + '">Edit</button></div>';
      };
      return '<div class="gs-stack" style="gap:clamp(22px,3vw,36px)">' + stepper(2) +
        '<div class="gs-two" style="align-items:start"><div class="gs-shot-wrap"><div class="gs-shot" data-gs-pv></div>' +
          '<div class="gs-shot-bar"><span class="gs-label">Your design</span><button class="gs-link" data-go="design">Edit design</button></div></div>' +
        '<div class="gs-stack" style="gap:clamp(20px,2.4vw,28px)">' +
          '<div class="gs-stack" style="gap:12px"><h1 class="gs-h1">One last look.</h1><p class="gs-lead">Once you confirm, we make your pair exactly like this.</p></div>' +
          '<div class="gs-rows">' +
            row('Size', '<span class="v">' + esc(sizeText(d)) + '</span>', '', 'design') +
            row('Personal text', d.name ? '<span class="vs">' + esc(d.name) + '</span>' + (d.date ? '<span class="v2">' + esc(d.date) + ' (on the other sneaker)</span>' : '') : '<span class="v2">No text</span>', '', 'design') +
            row('Ship to', '<span class="v">' + esc(f.name) + '</span>' + addrLines(f).map(function (l) { return '<span class="v2">' + esc(l) + '</span>'; }).join('') + (f.phone ? '<span class="v2">' + esc(f.phone) + '</span>' : ''), '', 'details') +
            row('Email', '<span class="v2">' + esc(f.email) + '</span>', '', 'details') +
            (f.wedding ? row('Wedding', '<span class="v2">' + esc(fmtDate(f.wedding)) + '</span>' + (weddingTooSoon(f.wedding) ? '<span class="gs-soon">' + SOON_TEXT + '</span>' : ''), '', 'details') : '') +
            '<div class="gs-row" style="grid-template-columns:1fr"><div><span class="gs-label">Delivery</span><span class="v2">Made by hand (up to 10 days) + tracked delivery (up to 7 days): at your door by ' + esc(etaFromToday()) + '.</span></div></div>' +
            '<div class="gs-pay"><span><b>To pay</b><small>Paid in full' + (g.from ? ' by ' + esc(g.from) : '') + '</small></span><span>$0</span></div>' +
          '</div>' +
          '<div class="gs-stack" style="gap:12px"><button class="gs-btn gs-btn--full" data-act="confirm">Confirm my pair</button>' +
            '<span class="gs-note">We’ll email your order confirmation to ' + esc(f.email) + '. For the security of your gift, ' +
              (g.from ? esc(g.from) : 'the person who sent it') + ' also gets a short note that it has been claimed, with the delivery city only. Your design stays a surprise.</span></div>' +
        '</div></div></div>';
    },

    // 05 Order placed (Claude Design). Tracking comes in the next stage.
    placed: function (g) {
      var o = S.placed || {};
      var wedding = o.wedding ? fmtDate(o.wedding) : '';
      var steps = [
        'We make your pair by hand: up to 10 days.',
        'Tracked delivery takes up to 7 days. You get an email with tracking the day it ships.',
        o.rush ? 'Your wedding' + (wedding ? ' on ' + wedding : '') + ' is very soon. We’ll email you within a day about timing.'
          : (o.expectedBy ? 'Expected at your door by ' + o.expectedBy + '.' : 'Delivery to your door is already paid.') + (wedding ? ' Well before your wedding on ' + wedding + '.' : '')
      ];
      return '<div class="gs-two"><div class="gs-shot" data-gs-pv></div>' +
        '<div class="gs-stack">' +
          '<span class="gs-kicker">Order ' + esc(o.orderName) + '</span>' +
          '<h1 class="gs-h1" style="font-size:clamp(32px,4.6vw,52px)">They’re yours, <span class="gs-serif">' + esc(g.first || '') + '.</span></h1>' +
          '<p class="gs-lead">' + (g.from ? 'We’ve let ' + esc(g.from) + ' know you’ve claimed your gift.' : 'Your gift is claimed and your pair is on its way to our workshop.') + '</p>' +
          '<div class="gs-rows">' + steps.map(function (s, i) {
            return '<div class="gs-row" style="grid-template-columns:34px minmax(0,1fr)"><span class="gs-label" style="color:var(--faint)">0' + (i + 1) + '</span><span class="v2" style="color:var(--ink2)">' + esc(s) + '</span></div>';
          }).join('') + '</div>' +
          '<div class="gs-rows">' +
            '<div class="gs-row" style="grid-template-columns:1fr"><div><span class="gs-label">Your pair</span><span class="v">' + esc(o.size) + '</span>' + (o.inscription ? '<span class="vs">' + esc(o.inscription) + '</span>' : '') + '</div></div>' +
            '<div class="gs-row" style="grid-template-columns:1fr"><div><span class="gs-label">Ship to</span>' + (o.shipTo || []).map(function (l) { return '<span class="v2">' + esc(l) + '</span>'; }).join('') + '</div></div>' +
          '</div>' +
          '<span class="gs-note">Your confirmation is on its way to ' + esc(o.email) + '. Something wrong with the address? <a href="mailto:support@crazysneak.com?subject=' + encodeURIComponent('Order ' + (o.orderName || '')) + '">Write to us</a> within 24 hours.</span>' +
        '</div></div>';
    },

    // Preview only: where her journey continues after the design.
    previewEnd: function (g) {
      return '<div class="gs-msg"><span class="gs-kicker">Preview</span>' +
        '<h1 class="gs-h1">That’s the design part.</h1>' +
        '<p class="gs-lead">Next, ' + esc(g.first || 'she') + ' adds her delivery address, takes one last look and confirms. Her pair then goes to our workshop, and you get a short note that she has claimed her gift.</p>' +
        '<p class="gs-lead">Nothing you tried here was saved. Send her the personal link from your email when you’re ready.</p>' +
        '<div class="gs-actions"><button class="gs-btn gs-btn--ghost" data-go="design">Back to the designer</button><button class="gs-link" style="align-self:center" data-go="open">Back to the start</button></div></div>';
    },
    usedPreview: function (g) {
      return '<div class="gs-msg"><span class="gs-kicker">Preview</span>' +
        '<h1 class="gs-h1">' + esc(g.first || 'She') + ' has already claimed her gift.</h1>' +
        '<p class="gs-lead">Her design stays a surprise. Questions? <a href="mailto:support@crazysneak.com">support@crazysneak.com</a></p></div>';
    },

    used: function (g) {
      return '<div class="gs-msg"><span class="gs-kicker">Gift for ' + esc(g.first || 'you') + '</span>' +
        '<h1 class="gs-h1">This gift has already been claimed.</h1>' +
        '<p class="gs-lead">If that was you, your order is on its way through. If it wasn’t, tell us and we’ll look into it right away.</p>' +
        '<div class="gs-actions"><a class="gs-btn gs-btn--ghost" href="mailto:support@crazysneak.com?subject=Gift%20claimed%20by%20someone%20else">That wasn’t me</a></div></div>';
    },
    paused: function () {
      return '<div class="gs-msg"><span class="gs-kicker">Gift link</span><h1 class="gs-h1">This gift is on hold.</h1>' +
        '<p class="gs-lead">We’re checking something with the person who sent it. Nothing is lost — we’ll be in touch by email.</p>' +
        '<div class="gs-actions"><a class="gs-btn gs-btn--ghost" href="mailto:support@crazysneak.com">Contact us</a></div></div>';
    },
    invalid: function () {
      return '<div class="gs-msg"><span class="gs-kicker">Gift link</span><h1 class="gs-h1">This link doesn’t open a gift.</h1>' +
        '<p class="gs-lead">It may have been cut short. Scan the QR code on your card again, or type in the address printed under it.</p>' +
        '<div class="gs-actions"><a class="gs-btn gs-btn--ghost" href="mailto:support@crazysneak.com">Contact us</a></div></div>';
    },
    error: function () {
      return '<div class="gs-msg"><span class="gs-kicker">Connection</span><h1 class="gs-h1">Something didn’t load.</h1>' +
        '<p class="gs-lead">That’s on our side. Your gift and everything you’ve entered are safe.</p>' +
        '<div class="gs-actions"><button class="gs-btn" data-act="retry">Try again</button>' +
        '<span class="gs-note">Still stuck? <a href="mailto:support@crazysneak.com">Write to us</a>.</span></div></div>';
    }
  };

  var REQUIRED = { name: 'Add the name for the delivery.', line1: 'Add a street address.', city: 'Add a city.', zip: 'Add a ZIP or postcode.' };
  function validate(f) {
    var e = {};
    Object.keys(REQUIRED).forEach(function (k) { if (!String(f[k] || '').trim()) e[k] = REQUIRED[k]; });
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(f.email || '').trim())) e.email = 'This email doesn’t look complete.';
    return e;
  }

  var BIND = {
    details: function () {
      main.querySelectorAll('[data-f]').forEach(function (inp) {
        var k = inp.dataset.f;
        var onInput = function () {
          S.draft.details[k] = inp.value;
          if (k === 'wedding') { var w = main.querySelector('[data-gs-soon]'); if (w) w.hidden = !weddingTooSoon(inp.value); }
          if (S.tried) {
            var e = validate(S.draft.details);
            inp.classList.toggle('is-bad', !!e[k]);
            var msg = inp.parentNode.querySelector('.gs-err'); if (msg && !e[k]) msg.remove();
          }
          saveSoon();
        };
        inp.addEventListener('input', onInput);
        inp.addEventListener('change', onInput);
      });
      previewInto(main.querySelector('[data-gs-pv]'));
    },
    review: function () { previewInto(main.querySelector('[data-gs-pv]')); },
    placed: function () { previewInto(main.querySelector('[data-gs-pv]'), S.placed && S.placed.design); }
  };

  function previewInto(el, design) {
    var d = design || (S.draft && S.draft.design);
    if (el && S.cfg && d) window.GiftDesigner.preview(el, S.cfg, ASSET_BASE, d);
  }

  main.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-go],[data-act]');
    if (!t) return;
    if (t.dataset.go) { go(t.dataset.go); return; }
    var act = t.dataset.act;
    if (act === 'retry') { boot(); return; }
    if (act === 'to-review') {
      S.tried = true;
      S.errors = validate(S.draft.details);
      if (!S.draft.design.size) { go('design'); toast('Choose your size first — it’s the only required step.'); return; }
      if (Object.keys(S.errors).length) {
        show('details');
        var bad = main.querySelector('.is-bad'); if (bad) { bad.focus(); bad.scrollIntoView({ block: 'center' }); }
        return;
      }
      saveNow(); go('review'); return;
    }
    if (act === 'confirm') confirmPair(t);
  });

  // ---------- confirm: the one $0 order ----------
  // A random key kept in this browser. With it, the used gift later opens as "your order";
  // anyone else holding the card sees "already claimed".
  function claimKey() {
    var k = null;
    try { k = localStorage.getItem('gs-claim'); } catch (e) {}
    if (!k || !/^[0-9a-f]{32}$/.test(k)) {
      var b = new Uint8Array(16); crypto.getRandomValues(b);
      k = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
      try { localStorage.setItem('gs-claim', k); } catch (e) {}
    }
    return k;
  }
  var KEY = PREVIEW ? '' : claimKey();

  function confirmPair(btn, tries) {
    if (S.confirming && !tries) return;
    S.confirming = true;
    clearTimeout(S.saveTimer); S.saveTimer = null;
    btn.disabled = true;
    btn.innerHTML = '<span class="gs-spin"></span>Confirming…';
    var reset = function (msg) { S.confirming = false; btn.disabled = false; btn.textContent = 'Confirm my pair'; if (msg) toast(msg); };
    post('/api/recipient/confirm', {
      token: token, design: S.draft.design, details: S.draft.details, namePos: S.draft.namePos || '', claimKey: KEY
    }).then(function (res) {
      if (res.status === 200 && res.data.order) {
        S.confirming = false; S.done = true; S.placed = res.data.order;
        try { history.replaceState({ gs: 'placed' }, '', location.href); } catch (e) {}
        show('placed'); window.scrollTo(0, 0);
        return;
      }
      if (res.status === 409 && res.data.error === 'busy' && (tries || 0) < 6) { setTimeout(function () { confirmPair(btn, (tries || 0) + 1); }, 2000); return; }
      if (res.status === 409) { S.confirming = false; boot(); return; }
      if (res.status === 422 && res.data.missing) {
        reset();
        if (res.data.missing.indexOf('size') >= 0) { go('design'); toast('Choose your size first — it’s the only required step.'); }
        else { S.tried = true; S.errors = validate(S.draft.details); go('details'); toast('A few delivery details are missing.'); }
        return;
      }
      reset('We couldn’t confirm just now. Nothing was ordered — please try again.');
    }).catch(function () { reset('No connection. Nothing was ordered — please try again.'); });
  }

  function mountDesigner(host) {
    if (S.designer) { S.designer.relayout(); return; }
    S.designer = window.GiftDesigner.mount(host, {
      config: S.cfg, assetBase: ASSET_BASE, icons: ICONS, extraFontCss: EXTRA_FONT_CSS, initial: S.draft.design,
      doneLabel: PREVIEW ? 'See what happens next' : '',
      onChange: function (design) { S.draft.design = design; saveSoon(); },
      onDone: function (design) {
        S.draft.design = design;
        if (PREVIEW) { go('previewEnd'); return; }
        S.draft.namePos = S.designer.namePos();
        saveNow();
        go('details');
      }
    });
    setSaved(PREVIEW ? 'Preview · not saved' : (S.draft.rev > 0 ? 'Saved ✓' : ''));
  }

  // ---------- start ----------
  function boot() {
    show('loading');
    if (!token) { show('invalid'); return; }
    Promise.all([
      S.cfg ? Promise.resolve(S.cfg) : fetch(CONFIG_URL).then(function (r) { if (!r.ok) throw new Error('config'); return r.json(); }),
      post('/api/recipient/open', PREVIEW ? { token: token, preview: true } : { token: token, claimKey: KEY })
    ]).then(function (res) {
      S.cfg = res[0];
      var r = res[1];
      if (r.status === 404 || r.data.state === 'invalid') { show('invalid'); return; }
      if (r.status !== 200) throw new Error('open ' + r.status);
      S.gift = r.data.gift;
      if (r.data.state === 'placed') { S.done = true; S.placed = r.data.order; show('placed'); return; }
      if (r.data.state === 'used') { show(PREVIEW ? 'usedPreview' : 'used'); return; }
      if (r.data.state === 'paused') { show('paused'); return; }
      S.draft = r.data.draft;
      if (!S.draft.details.country) S.draft.details.country = guessCountry();
      try { history.replaceState({ gs: 'open' }, '', location.href); } catch (e) {}
      show('open');
    }).catch(function (e) { console.error('gift', e); show('error'); });
  }
  window.addEventListener('hashchange', function () { var t = (location.hash.match(/^#([0-9a-f]{24})\b/i) || [])[1] || ''; if (t !== token) location.reload(); });
  boot();
})();
